module.exports = __webpack_public_path__ + "assets/img/mask-wealth.adb113ff.png";